(() => {
  if (window.luxsolBuilderLinksReady) return;
  window.luxsolBuilderLinksReady = true;
  document.addEventListener('click', event => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target instanceof Element && event.target.closest('[data-luxsol-build-cta]');
    if (!link) return;
    const builder = document.querySelector('aura-builder');
    const root = builder?.shadowRoot;
    const action = root?.querySelector('.lx-design-cta');
    if (action) {
      event.preventDefault();
      event.stopPropagation();
      action.click();
      action.focus({ preventScroll: true });
      requestAnimationFrame(() => requestAnimationFrame(() => {
        const header = document.querySelector('store-header');
        const offset = Math.max(0, header?.getBoundingClientRect().bottom || 0);
        window.scrollTo({ top: Math.max(0, window.scrollY + builder.getBoundingClientRect().top - offset - 12), behavior: 'instant' });
      }));
      return;
    }
    const target = root?.getElementById('pdp-build-options');
    if (!target) return;
    event.preventDefault();
    event.stopPropagation();
    root.querySelector('[data-lx-media="3d"]')?.click();
    requestAnimationFrame(() => {
      const offset = Math.max(Number.parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 110, 96) + 16;
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
      window.scrollTo({ top: Math.max(0, window.scrollY + target.getBoundingClientRect().top - offset), behavior: 'instant' });
    });
  }, { capture: true });
})();

(() => {
  if (location.hash !== '#build-pergola') return;
  let tries = 0;
  const ready = setInterval(() => {
    const builder = document.querySelector('aura-builder');
    const action = builder?.shadowRoot?.querySelector('.lx-design-cta');
    if (!action && ++tries < 200) return;
    clearInterval(ready);
    if (!action) return;
    action.click();
    action.focus({ preventScroll: true });
    requestAnimationFrame(() => {
      const offset = Math.max(0, document.querySelector('store-header')?.getBoundingClientRect().bottom || 0);
      window.scrollTo({ top: Math.max(0, scrollY + builder.getBoundingClientRect().top - offset - 12), behavior: 'instant' });
    });
  }, 150);
})();
